import {styled} from '@linaria/react';
import React, {ForwardedRef, forwardRef} from 'react';
import {FadePanel} from '../../atoms/FadePanel/FadePanel';

interface HorizontalListProps
  extends Omit<
    React.DetailedHTMLProps<
      React.HTMLAttributes<HTMLDivElement>,
      HTMLDivElement
    >,
    'ref'
  > {
  style?: React.CSSProperties;
  disableFade?: boolean;
}

export const HorizontalList = forwardRef<HTMLElement, HorizontalListProps>(
  function HorizontalList(
    {children, className, disableFade, ...props},
    forwardedRef,
  ) {
    return (
      <HorizontalListWrapper data-testid="horizontalList" className={className}>
        <HorizontalListSlider
          data-testid="list"
          ref={forwardedRef as ForwardedRef<HTMLDivElement>}
          position={'right'}
          size="2.5rem"
          disabled={disableFade}
          tabIndex={0}
          {...props}
        >
          {children}
        </HorizontalListSlider>
      </HorizontalListWrapper>
    );
  },
);

const HorizontalListWrapper = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
`;

export const HorizontalListSlider = styled(FadePanel)`
  --timeline-name: --horizontal-list-scroll-timeline;
  position: static;
  display: flex;
  flex-wrap: no-wrap;
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  scroll-timeline: var(--timeline-name) inline;
  &::-webkit-scrollbar {
    display: none;
  }
  &::after {
    animation: FadeOutEnd both linear;
    animation-timeline: var(--timeline-name);
  }

  @keyframes FadeOutEnd {
    0%,
    98% {
      opacity: 1;
    }

    100% {
      opacity: 0;
    }
  }
`;
